import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ReportBrief, ReportPreferences } from '../types';
import { reportsGateway } from './services';
export const interpretReport = createAsyncThunk(
  'negociacaoRelatorios/interpret',
  (args: { scope: string; text: string; currentBrief?: ReportBrief }) =>
    reportsGateway.interpret(args.scope, args.text, args.currentBrief),
);

export const loadReports = createAsyncThunk('negociacaoRelatorios/load', (scope: string) =>
  reportsGateway.load(scope),
);
export const createReport = createAsyncThunk(
  'negociacaoRelatorios/create',
  (args: { scope: string; brief: ReportBrief; key: string }) =>
    reportsGateway.create(args.scope, args.brief, args.key),
);
export const pollReport = createAsyncThunk(
  'negociacaoRelatorios/poll',
  (args: { scope: string; id: string }) => reportsGateway.get(args.scope, args.id),
);
export const cancelReport = createAsyncThunk(
  'negociacaoRelatorios/cancel',
  (args: { scope: string; id: string }) => reportsGateway.cancel(args.scope, args.id),
);
export const savePreferences = createAsyncThunk(
  'negociacaoRelatorios/preferences',
  (args: { scope: string; preferences: ReportPreferences }) =>
    reportsGateway.preferences(args.scope, args.preferences),
);
